import {
  TOGGLE_AREA_ENTRY_STRATEGY,
  TOGGLE_AREA_ENTRY_STRATEGY_ERROR,
  TOGGLE_AREA_ENTRY_STRATEGY_SUCCESS,
} from './actionTypes';

export const toggleAreaEntryStrategy = ({ token, updatedBy, id, active, history }) => {
  return {
    type: TOGGLE_AREA_ENTRY_STRATEGY,
    payload: { token, updatedBy, id, active, history },
  };
};

export const toggleAreaEntryStrategySuccess = (message) => {
  return {
    type: TOGGLE_AREA_ENTRY_STRATEGY_SUCCESS,
    payload: message,
  };
};

export const toggleAreaEntryStrategyFailure = (message) => {
  return {
    type: TOGGLE_AREA_ENTRY_STRATEGY_ERROR,
    payload: message,
  };
};
